<template>
  <div id="notTableMainBody">
    <div id="notTableBody" v-if="notifications">
      <div id="headers">
        <div id="heading" class="cellColumn">Title</div>
        <div id="content" class="cellColumn">Message</div>
        <div id="cellData" class="cellColumn">Link</div>
        <div id="cellData" class="cellColumn">Image</div>
        <div id="cellData" class="cellColumn">Date</div>
        <div id="cellButtonContainer" class="cellColumn"></div>
      </div>

      <div id="rowsContainer">
        <!-- <v-data-table
            style="width:90%"
              :headers="headers"
              :items="this.filteredNotifications"
              :search="search"
            ></v-data-table> -->
        <div v-for="not in this.filteredNotifications" :key="not.id" class="cellContainer">
          <NotificationCell v-bind:notification="not" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Notification from "../models/notification";
import NotificationCell from "../components/NotificationCell";

export default {
  name: "NotificationTable",
  components: {
    NotificationCell
  },
  data() {
    return {
      app_id: "8fb80b4e-299a-404a-aeab-1ba0a0db9430",
      notifications: null,
      headers: [
          {
            text: 'User Name',
            align: 'start',
            value: 'name',
          },
          { text: 'Email', value: 'email' },
          { text: 'Date created', value: 'dateCreated' },
          { text: 'Last active', value: 'lastActive' },
          { text: 'Actions', value: 'actions' },
        ],
      filteredNotifications: null,
      popupData: {
        header: "My popup",
        body: "hello world",
        footer: "divine inc.",
        display: "none"
      }
    };
  },
  props: {
    tableCategory: String
  },
  watch: {
    tableCategory: function() {
      this.filterNotifications();
    }
  },
  methods: {
    async getNotifications() {
      var headers = {
        Authorization: "Basic YmI4OGIwODUtMTM4NC00YTY1LTkyMTktNjNhZDMzZmNhZTIx"
      };
      const request = new Request(
        `https://onesignal.com/api/v1/notifications?app_id=${this.app_id}`,
        {
          port: 443,
          method: "GET",
          headers: headers
        }
      );
      const res = await fetch(request);
      const { notifications } = await res.json();
      console.log(notifications);
      var notificationsArray = [];
      for (var index = 0; index < notifications.length; index++) {
        const not = Notification.from(notifications[index]);
        if (!not.canceled) {
          not.delivery = not.queued_at == not.send_after
          notificationsArray.push(not);
        }
      }
      this.notifications = notificationsArray;
      this.filterNotifications();
      console.log("testtt");
    },
    filterNotifications() {
      console.log(this.tableCategory);
      switch (this.tableCategory) {
        case "Scheduled":
          this.filteredNotifications = this.notifications.filter(not =>
            !this.isFutureDate(not)
          );
          console.log(this.filteredNotifications)
          break
        case "Published":
          this.filteredNotifications = this.notifications.filter(
            not => this.isFutureDate(not)
          )
          break;
        default:
          break;
      }
    },
    isFutureDate(notification) {
      let currentUnixDate = Math.round(new Date().getTime() / 1000);
      return notification.send_after < currentUnixDate;
    }
  },
  beforeMount() {
    this.getNotifications();
  }
};
</script>

<style scoped>
.cellContainer {
    overflow: hidden !important;
  width: 100%;
}
.cellColumn {
  overflow: hidden !important;

  display: flex;
  justify-content: left;
  align-items: center;
  text-align: left;
  height: 100%;
  margin: 0 10px 0 10px;
}
#notTableMainBody {
    overflow: hidden !important;

  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 rgba(43, 45, 55, 0.01);
  background-color: #ffffff;
  padding-bottom: 40px;
  display: flex;
  /* flex-direction: column; */
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
}
#notTableBody {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#headers {
  overflow: hidden;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: left;
  align-items: center;
  background-color: rgba(16, 156, 241, 0.05);
  color: #109cf1;
  font-weight: 500;
}
#heading {
  overflow: hidden;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;
  width: 12%;
  text-align: center;
}
#content {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;
  overflow: hidden;
  width: 35%;
  text-align: left;
}
#cellData {
  overflow: hidden;
  width: 15%;
  text-align: left;
}
#cellButtonContainer {
  overflow: hidden;
  width: 5%;
}
#rowsContainer {
  overflow: hidden;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
}
body {
  overflow: hidden !important;
}
* {
    overflow: hidden !important;

}
</style>